<template>
  <el-dialog :visible.sync="visible" title="智能添加配置" width="1100px" :before-close="close">
    <div class="automatic-content" style="margin-bottom:100px">
      <h4 style="font-size:15px;margin-bottom:10px">智能自动添加</h4>
      <!-- <div class="item f--c">
        <div class="title">商品默认排序:</div>
        <el-select v-model="form.rule.defaultSort" style="width:160px">
          <el-option :value="1" label="上架时间升序"></el-option>
          <el-option :value="2" label="上架时间倒序"></el-option>
          <el-option :value="3" label="总销量升序"></el-option>
          <el-option :value="4" label="总销量倒序"></el-option>
          <el-option :value="5" label="价格升序"></el-option>
          <el-option :value="6" label="价格倒序"></el-option>
        </el-select>
      </div> -->
      <div v-if="form.rule.level === 1" class="item f--c">
        <div class="title">发货国家设置:</div>
        <el-select size="medium" v-model="form.rule.country" @change="getWarehouseList(form.rule)" clearable style="width:160px">
          <el-option v-for="item in countryList" :key="item.country" :value="item.country" :label="item.countryCn" />
        </el-select>
        <div class="title" style="margin-left:100px">发货仓库:</div>
        <el-select size="medium" v-model="form.rule.warehouseCode" :disabled="!form.rule.country" clearable style="width:160px">
          <el-option v-for="item in form.rule.warehouseList" :key="item.warehouseCode" :value="item.warehouseCode" :label="item.warehouseName" />
        </el-select>
      </div>
      <div class="item f--c">
        <div class="title">筛选条件:</div>
        <div>全部满足以下条件的产品才能进入专辑</div>
      </div>
      <div class="item f--c">
        <div class="title"></div>
        <div class="ruleList">
          <div v-for="(item, index) in condition.rules" :key="`rule${item.uuid||index}`">
            <condition-item :conditionList="conditionList" :groupItem="item" :showDelete="condition.rules.length>1" :categoryOptions="categoryOptions" :condition="condition" @deleteCondition="deleteRule('condition', index)" />
          </div>
          <el-button type="text" @click="addrule('condition')"><i class="iconfont icon-add-line"></i>新增条件</el-button>
        </div>
      </div>
      <div v-if="condition.groups && condition.groups.length" class="item f--c" style="align-items:flex-start;">
        <div class="title">设置二级:</div>
        <div>
          <div class="packet" v-for="(item, index) in condition.groups" :key="`groups${index}`">
            <div class="item f--c">
              <div class="title" style="width:120px">分组名称:</div>
              <div class="f-b-c" style="width:100%;padding-right:30px">
                <el-input v-model="item.groupName" size="medium"  placeholder="请输入" style="width:300px;"></el-input>
                <el-popconfirm
                  v-if="condition.groups.length>1"
                  title="确定要删除此组吗？"
                  @confirm="deleteRule('group', index)"
                >
                  <el-button slot="reference" type="text" style="color:#888">删除本组</el-button>
                </el-popconfirm>
              </div>
            </div>
            <div class="item f--c">
            <div class="title" style="width:120px">发货国家设置:</div>
              <el-select v-model="item.country" @change="getWarehouseList(item)" clearable style="width:160px">
                <el-option v-for="item in countryList" :key="item.country" :value="item.country" :label="item.countryCn" />
              </el-select>
              <div class="title" style="width:120px">发货仓库:</div>
              <el-select v-model="item.warehouseCode"  :disabled="!item.country" clearable style="width:160px">
                <el-option v-for="item in item.warehouseList" :key="item.warehouseCode" :value="item.warehouseCode" :label="item.warehouseName" />
              </el-select>
            </div>
            <div class="item f--c" style="align-items:flex-start;">
              <div class="title" style="width:120px">特殊筛选条件:</div>
              <div class="ruleList">
                <div v-for="(t, i) in item.rules" :key="`groups_rule${t.uuid||i}`">
                  <condition-item :conditionList="conditionList" :groupItem="t" :showDelete="item.rules.length>1" :categoryOptions="categoryOptions" :condition="condition" @deleteCondition="deleteRule('condition', index, i)" />
                </div>
                <el-button type="text" @click="addrule('condition', index)"><i class="iconfont icon-add-line"></i>新增条件</el-button>
              </div>
            </div>
          </div>
          <div>
            <el-button type="text" @click="addrule('group')"><i class="iconfont icon-add-line"></i>新增分组</el-button>
          </div>
        </div>
      </div>
      <div class="foot-btn f-c-c">
        <!-- <el-popconfirm
          v-if="!id"
          title="确定要清除已选设置么？"
          @confirm="getAlbumModuleDetail(1)"
        >
          <el-button slot="reference" size="medium">清空已选，上一步</el-button>
        </el-popconfirm> -->
        <!-- <el-button size="medium" type="primary" @click="submit" style="margin-left:20px">确认设置</el-button> -->
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button type="primary" size="medium" @click="confirm">确认设置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import conditionItem from './conditionItem.vue';
import _ from 'lodash';
export default {
  components: { conditionItem },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    condition: {
      type: Object,
      default: () => {}
    },
    countryList: {
      type: Array,
      default: () => []
    },
    conditionList: {
      type: Array,
      default: () => []
    },
    categoryOptions: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      visible: false,
      radio: 1,

      page: '',
      position: '',
      priority: '',

      rawFormRule: '',
      rawCondition: undefined,
    }
  },
  methods: {
    show() {
      this.rawCondition = _.cloneDeep(this.condition)
      this.rawFormRule = _.cloneDeep(this.form.rule)
      this.visible = true
    },

    confirm() {
      this.$emit('submit')
      // this.close()
    },

    close(type) {
      this.visible = false
      if (type !== 'success') {
        this.$emit('resetData', this.rawCondition, this.rawFormRule)
      }
    },

    clear() {},

    addrule(type, i) {
      this.$emit('addrule', type, i)
    },
    deleteRule(type, index, i) {
      this.$emit('deleteRule', type, index, i)
    },
    getWarehouseList(row) {
      this.$emit('getWarehouseList', row)
    },
    submit() {
      this.$emit('submit')
    },
  }
}
</script>

<style lang="scss" scoped>
.album-config {
  .box {
    margin-bottom: 10px;
    padding: 20px 10px;

    h3 {
      margin-bottom: 20px;
    }

    .upload-img{
      height: 177px;
      font-size: 14px;
      /deep/ .el-upload {
        border: 1px dotted #999 !important;
        height: 100%;
      }
      .avatar-uploader-icon {
        font-size: 24px;
        font-weight: 600;
      }
      img {
        height: 16  0px;
        object-fit: cover;
      }
    }

    .item {
      display: flex;
      margin-bottom: 22px;

      .title {
        height: 40px;
        width: 110px;
        text-align: right;
        padding-right: 12px;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        flex-shrink: 0;
      }
      .content {
        display: flex;
        align-items: center;
      }
    }

    .automatic-content {
      .item {
        margin-bottom: 10px;
        font-size: 14px;
        color: #606266;

        .ruleList{
          >div{
            margin-bottom: 10px;
          }
        }

        .packet {
          border: 1px solid #ccc;
          width: 940px;
          padding: 10px 0;
          margin-bottom: 10px;
        }
        .packet:last-child {
          margin: 0;
        }
      }
    }

    .manual-content {
      padding: 0 20px;
      // padding-left: 150px;
      .packet{
        border: 1px solid #ccc;
        width: 940px;
        padding: 10px 20px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
